var m = require('mithril');
var go = require('gojs');
var edit = require('../../../../layout/components/edit');
var diagramConfiguration = require('../diagramConfiguration');
var loaders = require('../../../../layout/components/loaders');

const $ = go.GraphObject.make;  // for more concise visual tree definitions
const portCoverBrush = $(go.Brush, "Linear", { 0: "#2a2a2a", 1: "#f0f0f0", start: go.Spot.Bottom, end: go.Spot.Top });

// HTML-based context menu for multi-linked ports
function ensureLinksMenuDiv() {
  let div = document.getElementById('linksContextMenu');
  if (!div) {
    div = document.createElement('div');
    div.id = 'linksContextMenu';
    div.style.position = 'absolute';
    div.style.zIndex = 2000;
    div.style.background = '#222';
    div.style.border = '1px solid #444';
    div.style.borderRadius = '4px';
    div.style.padding = '4px 0';
    div.style.minWidth = '180px';
    // Make the menu scrollable when there are many items
    div.style.maxHeight = '320px'; // ~10 rows at ~32px each
    div.style.overflowY = 'auto';
    div.style.webkitOverflowScrolling = 'touch';
    // Prevent horizontal overflow on narrow screens
    div.style.maxWidth = 'calc(100vw - 16px)';
    // Hide horizontal scrollbars; we'll truncate long text instead
    div.style.overflowX = 'hidden';
    div.style.boxSizing = 'border-box';
    div.style.display = 'none';
    document.body.appendChild(div);
  }
  return div;
}

function hideLinksMenuDiv() {
  const div = document.getElementById('linksContextMenu');
  if (div) div.style.display = 'none';
}

// Hide the links menu when editing mode toggles on/off
if (edit && edit.on) {
  edit.on('enter', hideLinksMenuDiv);
  edit.on('toggle', hideLinksMenuDiv);
}

let linksMenuOutsideHandler = null;
const MAX_LINK_ITEMS = 6; // show this many, then offer "View all"

const linksHTMLMenu = $(go.HTMLInfo, {
  show: function(obj, diagram, tool) {
    const data = obj && obj.part ? obj.part.data : null;
    const connections = (data && data.linkedConnections) || [];
    const links = (data && data.linkedEquipments) || [];
    const div = ensureLinksMenuDiv();
    // Reset expanded flag on initial show unless already set
    const expanded = div.dataset.expanded === 'true';
    // Match the port label color: blue when linked (and not editing), else white
    const textColor = (!edit.vm.editing() && ((Array.isArray(connections) && connections.length > 0) || (Array.isArray(links) && links.length > 0))) ? '#58ABE2' : '#FFFFFF';
    // If not multiple links or editing, hide and optionally route on single
    if (edit.vm.editing()) {
      this.hide(diagram, tool);
      return;
    }
    // Build menu content
    div.innerHTML = '';
    div.style.color = textColor;

    // Guard to avoid accidental click-through when menu opens under the finger
    const openGuard = () => {
      const el = document.getElementById('linksContextMenu');
      if (!el) return true;
      const ts = parseInt(el.dataset.openTs || '0');
      return (Date.now() - ts) > 250; // allow clicks only after 250ms
    };

    // Group by target equipment ("other") like megaMenu
    const groups = [];
    const byOther = new Map();
    if (Array.isArray(connections) && connections.length) {
      connections.forEach(conn => {
        const other = conn && conn.other ? conn.other : {};
        const otherRidRaw = other['@rid'] || '';
        const otherRid = otherRidRaw.toString().startsWith('#') ? otherRidRaw.slice(1) : otherRidRaw;
        const otherClass = other['@class'] || '';
        const otherName = other.name || otherClass;
        if (!otherRid || !otherClass) return;
        if (!byOther.has(otherRid)) {
          const group = { otherRid, otherClass, otherName, paths: [] };
          byOther.set(otherRid, group);
          groups.push(group);
        }
        const group = byOther.get(otherRid);
        const feedsPaths = Array.isArray(conn && conn.feedsPaths) ? conn.feedsPaths : [];
        if (feedsPaths.length) {
          feedsPaths.forEach(fp => {
            const path = Array.isArray(fp && fp.path) ? fp.path : [];
            // filter and map nodes, skip the displayed other equipment
            const nodes = path
              .filter(node => node && node['@rid'] && node['@rid'] !== other['@rid'])
              .map(node => ({
                rid: node['@rid'].toString().startsWith('#') ? node['@rid'].slice(1) : node['@rid'],
                cls: node['@class'] || '',
                name: node.name || node['@class'] || ''
              }));
            group.paths.push(nodes);
          });
        } else {
          // no paths info — still create a group without paths
          if (!group.paths.length) group.paths = [];
        }
      });
    } else if (Array.isArray(links) && links.length) {
      // fallback grouping by simple links (no path info)
      links.forEach(le => {
        const rid = (le.rid || '').toString().startsWith('#') ? le.rid.slice(1) : le.rid;
        const group = { otherRid: rid, otherClass: le.class || '', otherName: le.name || le.class || '', paths: [] };
        groups.push(group);
      });
    }

    if (!groups.length) {
      this.hide(diagram, tool);
      return;
    }

    // Render groups
    groups.forEach((g, idx) => {
      // group container
      const groupDiv = document.createElement('div');
      groupDiv.style.padding = '6px 0px';
      if (idx > 0) groupDiv.style.borderTop = '1px solid #444';

      // header: other equipment name (clickable) with bullet to indicate level
      const headerRow = document.createElement('div');
      headerRow.style.display = 'flex';
      headerRow.style.alignItems = 'center';
      headerRow.style.padding = '2px 12px 2px 12px';
      const headerBullet = document.createElement('span');
      headerBullet.textContent = '•';
      headerBullet.style.color = '#FFFFFF';
      headerBullet.style.marginRight = '6px';
      headerBullet.style.whiteSpace = 'nowrap';
      headerRow.appendChild(headerBullet);
      const headerLink = document.createElement('span');
      headerLink.textContent = g.otherName;
      headerLink.style.color = textColor;
      headerLink.style.cursor = 'pointer';
      headerLink.style.whiteSpace = 'nowrap';
      headerLink.style.overflow = 'hidden';
      headerLink.style.textOverflow = 'ellipsis';
      headerLink.style.flex = '1 1 auto';
      headerLink.style.minWidth = '0';
      headerLink.title = g.otherClass ? `${g.otherName} (${g.otherClass})` : g.otherName;
      headerLink.onmouseenter = () => { headerLink.style.textDecoration = 'underline'; };
      headerLink.onmouseleave = () => { headerLink.style.textDecoration = 'none'; };
      headerLink.onclick = () => {
        if (!openGuard()) return;
        const cls = (g.otherClass || '').toLowerCase();
        if (cls && g.otherRid) m.route.set(`/equipment/${cls}/${g.otherRid}`);
        tool.doCancel();
        linksHTMLMenu.hide(diagram, tool);
      };
      headerRow.appendChild(headerLink);
      groupDiv.appendChild(headerRow);

      // Subgroup by first node in path (e.g., Level X Supply Air Plenums)
      const subMap = new Map();
      (g.paths || []).forEach(nodes => {
        if (!nodes || !nodes.length) return;
        const first = nodes[0];
        const key = `${first.cls}|${first.rid}`;
        if (!subMap.has(key)) subMap.set(key, { first, tails: [] });
        subMap.get(key).tails.push(nodes.slice(1));
      });

      const subgroups = Array.from(subMap.values());

      // If there are no paths or subgroups, nothing else to render under header
      subgroups.forEach((sg, sidx) => {
        // sub-header for first path node (clickable) with bullet to indicate level
        const subRow = document.createElement('div');
        subRow.style.display = 'flex';
        subRow.style.alignItems = 'center';
        subRow.style.padding = '2px 12px 2px 18px';
        const subBullet = document.createElement('span');
        subBullet.textContent = '•';
        subBullet.style.color = '#FFFFFF';
        subBullet.style.marginRight = '6px';
        subBullet.style.whiteSpace = 'nowrap';
        subRow.appendChild(subBullet);
        const subLink = document.createElement('span');
        subLink.textContent = sg.first.name;
        subLink.style.color = textColor;
        subLink.style.cursor = 'pointer';
        subLink.style.whiteSpace = 'nowrap';
        subLink.style.overflow = 'hidden';
        subLink.style.textOverflow = 'ellipsis';
        subLink.style.flex = '1 1 auto';
        subLink.style.minWidth = '0';
        subLink.title = sg.first.cls ? `${sg.first.name} (${sg.first.cls})` : sg.first.name;
        subLink.onmouseenter = () => { subLink.style.textDecoration = 'underline'; };
        subLink.onmouseleave = () => { subLink.style.textDecoration = 'none'; };
        subLink.onclick = () => {
          if (!openGuard()) return;
          const cls = (sg.first.cls || '').toLowerCase();
          if (cls && sg.first.rid) m.route.set(`/equipment/${cls}/${sg.first.rid}`);
          tool.doCancel();
          linksHTMLMenu.hide(diagram, tool);
        };
        subRow.appendChild(subLink);
        groupDiv.appendChild(subRow);

        // tails under the sub-header
        sg.tails.forEach(tail => {
          if (!tail || tail.length === 0) return; // skip empty tails (only first-level node)
          const row = document.createElement('div');
          row.style.display = 'flex';
          row.style.flexWrap = 'nowrap';
          row.style.alignItems = 'center';
          row.style.padding = '2px 12px 2px 24px';
          row.style.whiteSpace = 'nowrap';
          row.style.overflow = 'hidden';

          const bullet = document.createElement('span');
          bullet.textContent = '•';
          bullet.style.color = '#FFFFFF';
          bullet.style.marginRight = '6px';
          bullet.style.whiteSpace = 'nowrap';
          row.appendChild(bullet);

          // Container to hold the path segments and allow truncation with ellipsis
          const pathContainer = document.createElement('span');
          pathContainer.style.display = 'flex';
          pathContainer.style.flex = '1 1 auto';
          pathContainer.style.minWidth = '0';
          pathContainer.style.overflow = 'hidden';
          pathContainer.style.textOverflow = 'ellipsis';
          pathContainer.style.whiteSpace = 'nowrap';

          tail.forEach((n, i) => {
            const seg = document.createElement('span');
            seg.textContent = n.name;
            seg.style.color = textColor;
            seg.style.cursor = 'pointer';
            seg.style.whiteSpace = 'nowrap';
            seg.style.overflow = 'hidden';
            seg.style.textOverflow = 'ellipsis';
            seg.title = n.cls ? `${n.name} (${n.cls})` : n.name;
            seg.onmouseenter = () => { seg.style.textDecoration = 'underline'; };
            seg.onmouseleave = () => { seg.style.textDecoration = 'none'; };
            seg.onclick = () => {
              if (!openGuard()) return;
              const cls = (n.cls || '').toLowerCase();
              if (cls && n.rid) m.route.set(`/equipment/${cls}/${n.rid}`);
              tool.doCancel();
              linksHTMLMenu.hide(diagram, tool);
            };
            pathContainer.appendChild(seg);

            if (i < tail.length - 1) {
              const slash = document.createElement('span');
              slash.textContent = ' / ';
              slash.style.color = '#FFFFFF';
              slash.style.cursor = 'default';
              slash.style.whiteSpace = 'nowrap';
              pathContainer.appendChild(slash);
            }
          });
          row.appendChild(pathContainer);
          groupDiv.appendChild(row);
        });
      });

      div.appendChild(groupDiv);
    });
    // If not expanded and there are more items, add a "View all" control
    // No pagination; list every possible path as its own option
    // Position at mouse, accounting for diagram's page offset and scroll
    const vp = diagram.lastInput.viewPoint; // in diagram view coords (viewport-relative to the canvas)
    const drect = diagram.div.getBoundingClientRect(); // viewport coords of the diagram element
    const scrollX = window.pageXOffset || document.documentElement.scrollLeft || 0;
    const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    const clickPageX = drect.left + scrollX + vp.x;
    const clickPageY = drect.top + scrollY + vp.y;
    const margin = 8;
    // First show near the tap/click to measure size (use page coordinates)
    let pageLeft = clickPageX + margin;
    let pageTop = clickPageY + margin;
    div.style.left = `${pageLeft}px`;
    div.style.top = `${pageTop}px`;
    div.style.display = 'block';
    // record open time for click guard
    div.dataset.openTs = String(Date.now());

    // After displaying, adjust position to keep menu within viewport and prefer flipping sides if needed
    const rect = div.getBoundingClientRect(); // viewport coordinates of the menu
    // Convert initial pageLeft/pageTop to viewport for comparisons
    let vpLeft = pageLeft - (window.pageXOffset || document.documentElement.scrollLeft || 0);
    let vpTop = pageTop - (window.pageYOffset || document.documentElement.scrollTop || 0);

    // Horizontal: if overflowing right, try placing to the left of the tap
    if (vpLeft + rect.width > window.innerWidth - margin) {
      pageLeft = Math.max(margin + scrollX, clickPageX - rect.width - margin);
      vpLeft = pageLeft - scrollX;
    }
    // Vertical: if overflowing bottom, try placing above the tap
    if (vpTop + rect.height > window.innerHeight - margin) {
      pageTop = Math.max(margin + scrollY, clickPageY - rect.height - margin);
      vpTop = pageTop - scrollY;
    }
    // Final clamp within viewport bounds
    if (vpLeft + rect.width > window.innerWidth - margin) {
      pageLeft = Math.max(margin + scrollX, window.innerWidth - rect.width - margin + scrollX);
      vpLeft = pageLeft - scrollX;
    }
    if (vpTop + rect.height > window.innerHeight - margin) {
      pageTop = Math.max(margin + scrollY, window.innerHeight - rect.height - margin + scrollY);
      vpTop = pageTop - scrollY;
    }
    if (vpLeft < margin) {
      pageLeft = margin + scrollX;
      vpLeft = pageLeft - scrollX;
    }
    if (vpTop < margin) {
      pageTop = margin + scrollY;
      vpTop = pageTop - scrollY;
    }
    div.style.left = `${pageLeft}px`;
    div.style.top = `${pageTop}px`;

    // Close when clicking anywhere outside the menu (register after current event tick)
    if (linksMenuOutsideHandler) {
      document.removeEventListener('click', linksMenuOutsideHandler, false);
    }
    linksMenuOutsideHandler = function (evt) {
      const menu = document.getElementById('linksContextMenu');
      if (!menu) return;
      if (!menu.contains(evt.target)) {
        linksHTMLMenu.hide(diagram, tool);
      }
    };
    setTimeout(() => {
      document.addEventListener('click', linksMenuOutsideHandler, false);
    }, 0);
  },
  hide: function(diagram, tool) {
    const div = document.getElementById('linksContextMenu');
    if (div) {
      div.style.display = 'none';
      // Reset expanded state when hiding
      div.dataset.expanded = 'false';
    }
    if (linksMenuOutsideHandler) {
      document.removeEventListener('click', linksMenuOutsideHandler, false);
      linksMenuOutsideHandler = null;
    }
  }
});

function portTemplate(map, useGeoPositioning, submitCallback) {


  var nodePart = $(go.Node, "Table",
  {
    locationSpot: go.Spot.TopLeft,
    // Use HTMLInfo-based menu to avoid Adornment timing issues
    contextMenu: linksHTMLMenu,
  },
  new go.Binding("deletable", "", data => {
    return edit.vm.editing() && !(data && data.isExternalDiagramFlag);
  }),
  new go.Binding("selectable", "", data => {
    return edit.vm.editing();
  }),
  new go.Binding("movable", "", data => {
    return edit.vm.editing();
  }),
  useGeoPositioning ? 
    new go.Binding("location", "latlong", data => {
      const pos = map.project(data, map.getZoom());
      return new go.Point(pos.x, pos.y);
    }).makeTwoWay((pt, data) => {
      if (updatingGoJs) {
        return data.latlong; // no-op
      } else {
        const ll = map.unproject(L.point(pt.x, pt.y), map.getZoom());
        return [ll.lat, ll.lng];
      }
    })
  : 
    new go.Binding("location", "latlong", data => {
      return new go.Point(data[0], data[1]);
    }),
      // the body
    $(go.Panel, "Auto",
      {
        row: 1, column: 1, name: "BODY",
        stretch: go.GraphObject.Fill,
        padding: go.Margin.parse(`${(diagramConfiguration.calculateCellHeight() )/ 2} 0 ${(diagramConfiguration.calculateCellHeight() )/ 2} 0`),
      },
      $(go.Shape, { 
        //geometryString: gojsGeometry.toString(),
        fill: $(go.Brush, "Linear", { 
          0: "#333333", 
          0.41: "#333333",
          0.53: "#333333",
          0.55: "#333333",
          0.65: "#363636",
          0.73: "#414141",
          0.82: "#535353",
          0.9: "#6d6d6d",
          0.98: "#8d8d8d",
          1: "#999999",
          start: go.Spot.Left,
          end: go.Spot.Right
        }),
        strokeWidth: 0
      },
        new go.Binding("geometryString", "directionAndType", function(directionAndType) {
          var geometry
          if ((!directionAndType[0] && directionAndType[1] == 'output') || (directionAndType[0] && directionAndType[0] == 'right')) {
            geometry = new go.Geometry()
                .add(new go.PathFigure(2 * 20.20982114 - 5.0743261, 2 * 3.50148739 - 6.9410674)  // start at this point, reflected
                .add(new go.PathSegment(go.PathSegment.Line, 2 * 20.20982114 - 40.388266, 2 * 3.50148739 - 6.9410674))  // H: horizontal line, reflected
                .add(new go.PathSegment(go.PathSegment.Bezier, 2 * 20.20982114 - 37.866786, 2 * 3.50148739 - 3.5014876, 2 * 20.20982114 - 40.388266, 2 * 3.50148739 - 6.9410674, 2 * 20.20982114 - 37.866786, 2 * 3.50148739 - 3.5014876))  // c: cubic Bezier curve, reflected
                .add(new go.PathSegment(go.PathSegment.Line, 2 * 20.20982114 - 40.411076, 2 * 3.50148739 - 0.06190738))  // l: line, reflected
                .add(new go.PathSegment(go.PathSegment.Line, 2 * 20.20982114 - 5.0769761, 2 * 3.50148739 - 0.06190738))  // H: horizontal line, reflected
                .add(new go.PathSegment(go.PathSegment.Line, 2 * 20.20982114 - 0.03137614, 2 * 3.50148739 - 3.5014876))  // L: line, reflected
                .add(new go.PathSegment(go.PathSegment.Line, 2 * 20.20982114 - 5.0769761, 2 * 3.50148739 - 6.9410674).close()))  // L: line and close the path, reflected
          
          } 
          if ((!directionAndType[0] && directionAndType[1] == 'input') || (directionAndType[0] && directionAndType[0] == 'left')) {
            geometry = new go.Geometry()
                .add(new go.PathFigure(5.0743261, 6.9410674)  // start at this point
                .add(new go.PathSegment(go.PathSegment.Line, 40.388266, 6.9410674))  // H: horizontal line
                .add(new go.PathSegment(go.PathSegment.Bezier, 37.866786, 3.5014876, 40.388266, 6.9410674, 37.866786, 3.5014876))  // c: cubic Bezier curve, though it's used like a line here
                .add(new go.PathSegment(go.PathSegment.Line, 40.411076, 0.06190738))  // l: line
                .add(new go.PathSegment(go.PathSegment.Line, 5.0769761, 0.06190738))  // H: horizontal line
                .add(new go.PathSegment(go.PathSegment.Line, 0.03137614, 3.5014876))  // L: line
                .add(new go.PathSegment(go.PathSegment.Line, 5.0769761, 6.9410674).close()))  // L: line and close the path
          } 
          return geometry.toString();
        }),
      ),

      $(go.Panel, "Spot", {
        padding: 20
      },
        $(go.TextBlock, { 
          name: "PORTLABEL",
          textAlign: "center", 
          font: `${diagramConfiguration.fontSize - 3}pt 'Roboto Flex', monospace`, 
          stroke: "#FFFFFF", 
          editable: true,
          wrap: go.TextBlock.None,
          // Show context menu with full path options when not editing
          click: function(e, obj) {
            if (edit.vm.editing()) return;
            const part = obj.part;
            const diagram = part.diagram;
            const tool = diagram && diagram.toolManager && diagram.toolManager.contextMenuTool;
            if (diagram && tool) {
              e.handled = true;
              linksHTMLMenu.show(part, diagram, tool);
            }
          },
          textEdited: function(textBlock, previousText, currentText) {
            let portRecord = textBlock.part.data;
            let portEdited = Object.values(portRecord.parentRecordPorts).find(port => `Port_${port.id}` == portRecord.key);
            portEdited.name = currentText;
            return loaders.requestWithLoader({
              loader: 'main',
              url: '/api/v1/customequipment/' + portRecord.parentRid.slice(1) + '/ports',
              method: 'PUT',
              body: {ports: portRecord.parentRecordPorts}
            })
          }
        },
          new go.Binding("text", "name").makeTwoWay(),
          new go.Binding("editable", "isExternalDiagramFlag", function(isExternalDiagramFlag) {
            return !isExternalDiagramFlag;
          }),
          new go.Binding("stroke", "linkedEquipments", function(arr) {
            return (!edit.vm.editing() && Array.isArray(arr) && arr.length > 0) ? "#58ABE2" : "#FFFFFF";
          }),
          new go.Binding("font", "linkedEquipments", function(arr) {
            const base = `${diagramConfiguration.fontSize - 3}pt 'Roboto Flex', monospace`;
            return (!edit.vm.editing() && Array.isArray(arr) && arr.length > 0) ? `bold ${base}` : base;
          }),
          new go.Binding("cursor", "linkedEquipments", function(arr) {
            return (!edit.vm.editing() && Array.isArray(arr) && arr.length > 0) ? "pointer" : "default";
          })
        )
      )
    ),  // end Auto Panel body

    $(go.Panel, "Vertical",
      new go.Binding("itemArray", "leftArray"),
      {
        row: 1, column: 0,
        itemTemplate:
          $(go.Panel,
            {
              _side: "left",  // internal property to make it easier to tell which side it's on
              fromSpot: go.Spot.Left, 
              toSpot: go.Spot.Left,
              cursor: "pointer",
              //contextMenu: portMenu
            },
            new go.Binding("portId", "portId"),
            new go.Binding("category", "category"),
            new go.Binding("fromLinkable", "type", function(type) {
              // Set fromLinkable to true if the node's type is "input"
              return type === "output" && edit.vm.editing();
            }),
            new go.Binding("toLinkable", "type", function(type) {
              // Set toLinkable to true if the node's type is "output"
              return type === "input" && edit.vm.editing();
            }),
            $(go.Shape, "Rectangle",
              {
                stroke: null, strokeWidth: 0,
                desiredSize: new go.Size(diagramConfiguration.calculateCellWidth(), diagramConfiguration.calculateCellHeight()),
                margin: new go.Margin(diagramConfiguration.calculateCellHeight() / 2, 0)
              },
              new go.Binding("fill", "portColor", function(portColor) {
                if(!edit.vm.editing()) {
                  return portCoverBrush;
                } else {
                  return portColor
                }
              }))
          )  // end itemTemplate
      }
    ), 
    $(go.Panel, "Horizontal",
      new go.Binding("itemArray", "topArray"),
      {
        row: 0, column: 1,
        itemTemplate:
          $(go.Panel,
            {
              _side: "top",
              fromSpot: go.Spot.Top, 
              toSpot: go.Spot.Top,
              cursor: "pointer",
              //contextMenu: portMenu
            },
            new go.Binding("fromMaxLinks", "type", function(type) {
              // Set fromLinkable to true if the node's type is "input"
              return type === "bidirectional" ? 1 : '';
            }),
            new go.Binding("toMaxLinks", "type", function(type) {
              // Set fromLinkable to true if the node's type is "input"
              return type === "bidirectional" ? 1 : '';
            }),
            new go.Binding("portId", "portId"),
            new go.Binding("category", "category"),
            new go.Binding("fromLinkable", "type", function(type) {
              // Set fromLinkable to true if the node's type is "input"
              return (type === "output" || type === "bidirectional") && edit.vm.editing();
            }),
            new go.Binding("toLinkable", "type", function(type) {
              // Set toLinkable to true if the node's type is "output"
              return (type === "input" || type === "bidirectional") && edit.vm.editing();
            }),
            $(go.Shape, "Rectangle",
              {
                stroke: null, strokeWidth: 0,
                desiredSize: new go.Size(diagramConfiguration.calculateCellWidth(), diagramConfiguration.calculateCellHeight()),
                margin: new go.Margin(0, diagramConfiguration.calculateCellWidth() / 2)
              },
              new go.Binding("fill", "portColor", function(portColor) {
                if(!edit.vm.editing()) {
                  return portCoverBrush;
                } else {
                  return portColor
                }
              }))
          )  // end itemTemplate
      }
    ),
    $(go.Panel, "Vertical",
      new go.Binding("itemArray", "rightArray"),
      {
        row: 1, column: 2,
        itemTemplate:
          $(go.Panel,
            {
              _side: "right",
              fromSpot: go.Spot.Right, 
              toSpot: go.Spot.Right,
              cursor: "pointer",
              //contextMenu: portMenu
            },
            new go.Binding("portId", "portId"),
            new go.Binding("category", "category"),
            new go.Binding("fromLinkable", "type", function(type) {
              // Set fromLinkable to true if the node's type is "input"
              return type === "output" && edit.vm.editing();
            }),
            new go.Binding("toLinkable", "type", function(type) {
              // Set toLinkable to true if the node's type is "output"
              return type === "input" && edit.vm.editing();
            }),
            $(go.Shape, "Rectangle",
              {
                stroke: null, strokeWidth: 0,
                desiredSize: new go.Size(diagramConfiguration.calculateCellWidth(), diagramConfiguration.calculateCellHeight()),
                margin: new go.Margin(diagramConfiguration.calculateCellHeight() / 2, 0)
              },
              new go.Binding("fill", "portColor", function(portColor) {
                if(!edit.vm.editing()) {
                  return portCoverBrush;
                } else {
                  return portColor
                }
              }))
          )  // end itemTemplate
      }
    ),
    $(go.Panel, "Horizontal",
      new go.Binding("itemArray", "bottomArray"),
      {
        row: 2, column: 1,
        itemTemplate:
          $(go.Panel,
            {
              _side: "bottom",
              fromSpot: go.Spot.Bottom, 
              toSpot: go.Spot.Bottom,
              cursor: "pointer",
              //contextMenu: portMenu
            },
            new go.Binding("portId", "portId"),
            new go.Binding("category", "category"),
            new go.Binding("fromLinkable", "type", function(type) {
              // Set fromLinkable to true if the node's type is "input"
              return type === "output" && edit.vm.editing();
            }),
            new go.Binding("toLinkable", "type", function(type) {
              // Set toLinkable to true if the node's type is "output"
              return type === "input" && edit.vm.editing();
            }),
            $(go.Shape, "Rectangle",
              {
                stroke: null, strokeWidth: 0,
                desiredSize: new go.Size(diagramConfiguration.calculateCellWidth(), diagramConfiguration.calculateCellHeight()),
                margin: new go.Margin(0, diagramConfiguration.calculateCellWidth() / 2)
              },
              new go.Binding("fill", "portColor", function(portColor) {
                if(!edit.vm.editing()) {
                  return portCoverBrush;
                } else {
                  return portColor
                }
              }))
          )  // end itemTemplate
      }
    ),
)

return nodePart
}

module.exports = portTemplate;
